import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsPath } from '#/modules/search/events/routing/searchGetEventsPath';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';

import type { VolunteerDropdownData } from './types/VolunteerDropdownData';

export const volunteerDropdownDataPt: VolunteerDropdownData = {
  search: {
    title: 'Busca',
    items: [
      {
        type: 'volop',
        title: 'Voluntariado',
        href: searchGetVolopsPath({
          locale: I18nLocale.PT,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'event',
        title: 'Eventos',
        href: searchGetEventsPath({ locale: I18nLocale.PT }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'idealist-movement',
        title: 'Movimento Idealista',
        description:
          'Bem Vindo ao Movimento Idealista. Aqui você encontra formas de se conectar e pode conhecer o ecossistema idealista para transformação social.',
        href: '/pt/movimento',
      },
      {
        type: 'recipes-for-action',
        title: 'Receitas para Ação',
        description: 'Boas ideias para fazer do mundo um lugar melhor.',
        href: 'pt/receitas?pq=',
      },
      {
        type: 'blog',
        title: 'Blog',
        description:
          'Artigos sobre dicas de carreira, voluntariado, captação de recursos, recrutamento e ativismo social.',
        href: 'pt/blog',
      },
    ],
  },
};
